(() => {
  if (!window.Dallas || window.Dallas.enableReveal === false) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const boot = () => {
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
      fallbackReveal();
      return;
    }

    gsap.registerPlugin(ScrollTrigger);
    document.documentElement.classList.add('has-gsap');

    const style = window.Dallas.revealStyle || 'slide';

    const fromVars = (styleName) => {
      if (styleName === 'fade') return { opacity: 0 };
      if (styleName === 'scale') return { opacity: 0, scale: 0.94 };
      return { opacity: 0, y: 48 };
    };

    document.querySelectorAll('[data-reveal]').forEach((el) => {
      gsap.from(el, {
        ...fromVars(style),
        duration: 0.95,
        ease: 'power3.out',
        scrollTrigger: {
          trigger: el,
          start: 'top 88%',
          toggleActions: 'play none none none'
        }
      });
    });

    document.querySelectorAll('[data-stagger]').forEach((grid) => {
      const items = grid.querySelectorAll(':scope > *');
      if (!items.length) return;
      gsap.from(items, {
        opacity: 0,
        y: 40,
        duration: 0.75,
        stagger: 0.1,
        ease: 'power3.out',
        scrollTrigger: {
          trigger: grid,
          start: 'top 85%',
          toggleActions: 'play none none none'
        }
      });
    });

    document.querySelectorAll('.marquee').forEach((el) => {
      const track = el.querySelector('.marquee__track');
      if (!track) return;
      gsap.from(track, {
        opacity: 0,
        y: 28,
        duration: 1,
        ease: 'power3.out',
        scrollTrigger: {
          trigger: el,
          start: 'top 92%',
          toggleActions: 'play none none none'
        }
      });
    });

    const hero = document.querySelector('[data-hero]');
    if (hero) {
      const logotype = hero.querySelector('[data-hero-logotype]');
      const slides = hero.querySelector('.hero__slides');
      const bgs = hero.querySelectorAll('.hero__bg img');

      if (logotype) {
        gsap.to(logotype, {
          yPercent: 35,
          ease: 'none',
          scrollTrigger: {
            trigger: hero,
            start: 'top top',
            end: 'bottom top',
            scrub: true
          }
        });
      }

      if (slides) {
        gsap.to(slides, {
          y: 90,
          opacity: 0.25,
          ease: 'none',
          scrollTrigger: {
            trigger: hero,
            start: 'top top',
            end: 'bottom top',
            scrub: true
          }
        });
      }

      if (bgs.length) {
        gsap.to(bgs, {
          yPercent: 12,
          scale: 1.06,
          ease: 'none',
          scrollTrigger: {
            trigger: hero,
            start: 'top top',
            end: 'bottom top',
            scrub: true
          }
        });
      }
    }

    // Soft parallax on full-bleed image sections
    document.querySelectorAll('.parallax__media img').forEach((img) => {
      gsap.fromTo(
        img,
        { yPercent: -8, scale: 1.08 },
        {
          yPercent: 8,
          scale: 1.08,
          ease: 'none',
          scrollTrigger: {
            trigger: img.closest('.parallax') || img.parentElement,
            start: 'top bottom',
            end: 'bottom top',
            scrub: true
          }
        }
      );
    });
  };

  const fallbackReveal = () => {
    const style = window.Dallas.revealStyle || 'slide';
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -8% 0px' }
    );

    document.querySelectorAll('[data-reveal]').forEach((el) => {
      el.classList.add('reveal', 'reveal--' + style);
      observer.observe(el);
    });

    document.querySelectorAll('[data-stagger]').forEach((grid) => {
      const items = Array.from(grid.children);
      items.forEach((item) => item.classList.add('stagger-item'));
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              items.forEach((item, i) => {
                setTimeout(() => item.classList.add('is-visible'), i * 100);
              });
              io.disconnect();
            }
          });
        },
        { threshold: 0.1, rootMargin: '0px 0px -8% 0px' }
      );
      io.observe(grid);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
